import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ITablaCalificaciones } from 'src/app/interfaces/calificaciones';

@Component({
  selector: 'app-ingreso-calificaciones-mobile',
  templateUrl: './ingreso-calificaciones-mobile.component.html',
  styleUrls: ['./ingreso-calificaciones-mobile.component.scss']
})
export class IngresoCalificacionesMobileComponent {
  dataSeleccion: any = []
  tablaCalificaciones: ITablaCalificaciones | null = null

  constructor(
    private router: Router
  ) {
    const routerData = this.router.getCurrentNavigation()?.extras?.state?.['data']
    if ( routerData?.dataSeleccion && routerData?.tablaCalificaciones ) {
      this.dataSeleccion = routerData.dataSeleccion
      this.tablaCalificaciones = routerData.tablaCalificaciones
    }
  }
}
